import React from 'react';
import { Box, Typography, Rating, FormControl } from '@mui/material';
import { SurveyComponent } from '../../../../models/SurveyTemplates';

interface RatingScaleFieldProps {
    field: SurveyComponent;
    value?: number;
    onChange?: (value: number | null) => void;
    disabled?: boolean;
}

const RatingScaleField: React.FC<RatingScaleFieldProps> = ({
    field,
    value,
    onChange,
    disabled = false
}) => {
    const scale = field.properties?.scale || 5;
    const scaleLabels = field.properties?.scaleLabels || [];

    const handleChange = (event: React.SyntheticEvent, newValue: number | null) => {
        onChange?.(newValue);
    };

    return (
        <FormControl component="fieldset" fullWidth disabled={disabled}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Rating
                    value={value || 0}
                    onChange={handleChange}
                    max={scale}
                    size="large"
                />
                {value && scaleLabels[value - 1] && (
                    <Typography variant="body2" color="text.secondary">
                        {scaleLabels[value - 1]}
                    </Typography>
                )}
            </Box>
            {scaleLabels.length > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                        {scaleLabels[0]}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {scaleLabels[scaleLabels.length - 1]}
                    </Typography>
                </Box>
            )}
        </FormControl>
    );
};

export default RatingScaleField;
